import { FormBase } from '../interfaces/formInterface';

export class DatePickerField extends FormBase<string> {
  controlType = 'datepicker';
  type: string;

  constructor(options: {} = {}) {
    super(options);
    this.type = options['type'] || '';
  }
}